import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=13a08557&scoped=true&"
import script from "./LandingLayout.vue?vue&type=script&lang=js&"
export * from "./LandingLayout.vue?vue&type=script&lang=js&"
import style0 from "./LandingLayout.vue?vue&type=style&index=0&id=13a08557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a08557",
  null
  
)

export default component.exports